<button mat-button [routerLink]="'/insure'">
    Home 
</button>

<button mat-button [routerLink]="'/insure/quote'">
    Quote 
</button>

<button mat-button [routerLink]="'/insure/buy'">
    Buy 
</button>

<button mat-button [routerLink]="'/insure/manage'">
    Manage 
</button>

<router-outlet></router-outlet>